import React from "react";
import EstornoPage from "./EstornoPage";
import McFishPage from "./McFishPage";

export interface useExternalRoutesProps {
  colorMode: any;
}
const useExternalRoutes = (props: useExternalRoutesProps) => {
  const routers = React.useMemo(
    () => [
      {
        path: "/external",
        element: <EstornoPage colorMode={props.colorMode} />
      },     
      {
        path: "/external/estorno",
        element: <EstornoPage colorMode={props.colorMode} />
      },
      {
        path: "/external/mcfish",
        element: <McFishPage colorMode={props.colorMode} />
      },     
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return routers;
};

export default useExternalRoutes;
